import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export var rangesIndex = {
  YTD: 0,
  '12M': 1,
  '36M': 2,
  '60M': 3,
  '120M': 4
};
export var timeseriesOptions = function timeseriesOptions(theme, events) {
  var initialTimeRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '36M';
  var isCompact = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    chart: _objectSpread({
      backgroundColor: theme.chartsBackgroundColor
    }, isCompact ? {
      height: 260
    } : {}),
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          chart: {
            height: 300
          }
        }
      }]
    },
    yAxis: {
      opposite: false,
      showFirstLabel: false,
      lineColor: theme.chartsAxisColor,
      labels: {
        align: 'right'
      }
    },
    xAxis: {
      type: 'datetime',
      lineColor: theme.chartsAxisColor
    },
    scrollbar: {
      enabled: false
    },
    navigator: {
      enabled: false
    },
    series: [],
    legend: {
      enabled: false
    },
    rangeSelector: {
      floating: false,
      buttonTheme: {
        fill: 'none',
        height: 20,
        width: 48,
        states: {
          hover: {
            fill: theme.colors.ui
          },
          select: {
            fill: theme.colors.uiL
          }
        },
        style: {
          fontSize: 14
        }
      },
      selected: rangesIndex.hasOwnProperty(initialTimeRange) ? rangesIndex[initialTimeRange] : 2,
      inputEnabled: true,
      inputDateFormat: '%b %e, %Y',
      inputStyle: {
        fontSize: 14,
        backgroundColor: 'white',
        color: theme.colors.primary,
        border: '1px solid silver',
        borderRadius: '5px',
        padding: '5px'
      },
      inputBoxHeight: 30,
      inputBoxWidth: 110,
      labelStyle: {
        fontSize: 18
      },
      buttons: [{
        id: 'ytd',
        type: 'ytd',
        count: 1,
        text: 'YTD',
        events: {
          click: function click() {
            events.onTimeRangeChange('YTD');
          }
        }
      }, {
        type: 'year',
        count: 1,
        text: '1A',
        events: {
          click: function click() {
            events.onTimeRangeChange('12M');
          }
        }
      }, {
        type: 'year',
        count: 3,
        text: '3A',
        events: {
          click: function click() {
            events.onTimeRangeChange('36M');
          }
        }
      }, {
        type: 'year',
        count: 5,
        text: '5A',
        events: {
          click: function click() {
            events.onTimeRangeChange('60M');
          }
        }
      }, {
        type: 'year',
        count: 10,
        text: '10A',
        events: {
          click: function click() {
            events.onTimeRangeChange('120M');
          }
        }
      }, {
        type: 'all',
        text: 'Todo'
      }]
    },
    title: {
      text: ''
    },
    plotOptions: {
      series: {
        pointInterval: 24 * 3600 * 1000,
        boostThreshold: 1
      }
    },
    boost: {
      debug: {
        timeRendering: true,
        showSkipSummary: true,
        timeSeriesProcessing: true
      }
    }
  };
};